import React, * as ReactDefault from 'react';
import PropTypes from 'prop-types';
import { configure } from 'mobx';

configure({ isolateGlobalState: true });

// eslint-disable-next-line no-import-assign
ReactDefault.PropTypes = PropTypes;
// eslint-disable-next-line react/no-deprecated
React.PropTypes = PropTypes;

React.Component.prototype.componentDidCatch = (error, errorInfo) => {
    try {
        window.console.error('Default error componentDidCatch', error, errorInfo);
    } catch (err) {
    }
};
